import TaskTypes from '../../constants/TaskTypes';

export const PENDING = 0;
export const STARTED = 1;
export const PROCESSING = 2;
export const FINISHED = 3;
export const FAILED = 4;

export function getTextByType(type) {
  switch (parseInt(type)) {
    case TaskTypes.ZENMONEY:
      return 'Синхронизация с Дзенмани';
    case TaskTypes.TINKOFF:
      return 'Синхронизация с "Т-инвестиции"';
    case TaskTypes.GOAL:
      return 'Идёт перерасчёт целей';
    case TaskTypes.STRATEGY:
    case TaskTypes.STRATEGY_CACHE:
      return 'Идёт рассчёт графика';
    case TaskTypes.GOAL_RECALC:
      return 'Идёт перерассчёт целей';
    case TaskTypes.PLAN_RECALC:
      return 'Идёт перерасчёт плана';
    case TaskTypes.ATON_FILE_PARSE:
    case TaskTypes.ATON_CRM_PARSE:
    case TaskTypes.BCS_FILE_PARSE:
      return 'Идёт загрузка брокерского отчета';
    case TaskTypes.FREEDOM_REPORT:
      return 'Синхронизация с Freedom Broker';
    case TaskTypes.BCS_API:
      return 'Синхронизация с БКС';
    case TaskTypes.REFRESH_API:
      return 'Очистка данных';
    case TaskTypes.RETURN_ACTIVES_BACKUP:
      return 'Идёт восстановление из точки';
    default:
      return '';
  }
}
